import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Cookies from 'js-cookie';
import styles from './JoinWaitlist.module.sass';
import Button from '../../../ui_kit/button/Button';
import { campaignsActions } from '../../../campaigns/actions';
import { campaignsObjectsSelector } from '../../../campaigns/selectors/campaigns';
import { userObjectSelector } from '../../../user/selectors/user';
import { modalsActions } from '../../../modals/actions';
import MODALS from '../../../modals/constants/modals';
import scrollToElement from '../../../services/smooth_scroll';

function JoinWaitlist(props) {
  const {
    className, voteRequest, campaignId, campaigns, user, openSignUpModal, disableButton,
  } = props;

  const campaign = campaigns.find((object) => object.id === campaignId);

  const {
    id, loading, is_voted: isVoted, is_winner: isWinner, variants,
    selectedVariantId,
  } = campaign;

  useEffect(() => {
    if (user && window.userLoggedInCallback) {
      window.userLoggedInCallback(user);
      window.userLoggedInCallback = null;
    }
  }, [user && user.id]);

  const voteButtonDisabled = !isWinner && variants.length > 0 && !selectedVariantId && !isVoted;

  const onClick = () => {
    if (isVoted || isWinner || loading) { return; }

    if (!disableButton && voteButtonDisabled) {
      scrollToElement('variants-select');
      return;
    }

    if (!user) {
      Cookies.set('signed_up_from', 'voting');

      openSignUpModal();

      window.userLoggedInCallback = (loggedInUser) => {
        if (loggedInUser.sign_in_count > 1 && loggedInUser.confirmed_at) {
          voteRequest(id, selectedVariantId, loggedInUser, true);
        } else {
          voteRequest(id, selectedVariantId, loggedInUser, false);
        }
      };

      return;
    }

    voteRequest(id, selectedVariantId, user, true);
  };

  return (
    <div className={`${styles['join-waitlist']} ${className}`}>
      { !isVoted && !isWinner && (
        <Button
          className={styles.button}
          text="JOIN WAITLIST"
          onClickHandler={onClick}
          loading={loading}
          disabled={disableButton && voteButtonDisabled}
          size="small"
          color="blue"
        />
      )}
      { isWinner && !isVoted && (
        <Button
          text="CAMPAIGN WINNER"
          size="small"
          color="blue"
        />
      )}
      { isVoted && (
        <Button
          text="THANKS FOR JOINING THE WAITLIST"
          size="small"
          color="blue"
        />
      )}
    </div>
  );
}

JoinWaitlist.propTypes = {
  className: PropTypes.string,
  voteRequest: PropTypes.func.isRequired,
  campaigns: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      loading: PropTypes.bool,
    }),
  ).isRequired,
  campaignId: PropTypes.number.isRequired,
  openSignUpModal: PropTypes.func.isRequired,
  user: PropTypes.shape({
    id: PropTypes.number,
  }),
  disableButton: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  user: userObjectSelector(state),
  campaigns: campaignsObjectsSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  voteRequest: (campaignId, variantId, user, showDefaultVoteDialog) => {
    dispatch(campaignsActions.voteRequest({
      campaignId, variantId, user, showDefaultVoteDialog,
    }));
  },
  openSignUpModal: () => dispatch(modalsActions.openModalRequest({
    modal: MODALS.JOIN_THE_LOUNGE_FOR_VOTING,
  })),
});

export default connect(mapStateToProps, mapDispatchToProps)(JoinWaitlist);
